
import React, {useEffect,useState} from 'react';
import Pagination from "react-js-pagination";
import Cookies from "universal-cookie";
import axios from "axios";
import Host from "../../../assets/js/Host";
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import UserForm from './UserForm';
import UserRoleForm from './UserRoleForm';

const cookies = new Cookies();
const token = cookies.get("token")
const language = cookies.get("language")?cookies.get("language"):"ar"
function Users() {

    const [loading, setloading] = useState(false);
    const [state, setData] = useState({
        users: ''
    });
    const [showUserForm, setshowUserForm] = useState(false);
    const [showUserRoleForm, setshowUserRoleForm] = useState(false);
    const [selectedUser, setselectedUser] = useState(null);
    const [pageSize,setPageSize]=useState(5)
    const [pageNumber,setPageNumber]=useState(1)
    const [row,setRow]=useState([])
    const params=null;

    
    const fetchData = async (pageNumber = 1) => {
        setloading(true)
        try {
            const result=await axios({
                url: Host + "users?page="+pageNumber,
                method: "get",
                headers: {
                "Authorization" : `Bearer ${token}`,
                    Accept:"application/json",
                    'X-localization':language,
                }
        
            })
            if(result && result.status == 200)
            {
                const users=result.data ;
                
                console.log(users);
                setData({
                    users:users 
                });
            } else if (result.data.status === false) {
                toast.error("Error")
            }
        } catch (error) {
            const responseResult=error.response            
            if (responseResult && responseResult.status === 400) {
                if(typeof responseResult.data.data === "object")
                {
                    const errorMessagesKeys = Object.keys(responseResult.data.data);
                    errorMessagesKeys.map((key)=>{
                    
                        responseResult.data.data[key].map((message)=>{
                            toast.error(message)
                        })
                    })
                }
                else{
                    toast.error(responseResult.data.data)
                }
                
            }
            else if(responseResult && responseResult.status === 401) {
                toast.error(responseResult.data.data)
                cookies.remove("token");
                window.location.href = "/"
            }
            else
            {
                toast.error("network error")
            }
        }
        setloading(false)
                   
    };
    const updateObject = async (object) => {
      
        setselectedUser(object)
        setshowUserForm(true)
    };
    const showRoles = (object) => {
        setselectedUser(object)
        setshowUserRoleForm(true)
    };
    
    const deleteObject = async (object) => {
        if (!window.confirm("Delete the item?")) {
            return
        }
        setloading(true)
        try {
            const result=await axios({
                url: Host + "users/"+object.id,
                method: "delete",
                headers: {
                "Authorization" : `Bearer ${token}`,
                    Accept:"application/json",
                    'X-localization':language,
                }
        
            })
            if(result && result.status == 200)
            {
                toast.error(result.data.data)
                fetchData();
            } else if (result.data.status === false) {
                toast.error("Error")
            }
        } catch (error) {
            const responseResult=error.response            
            if (responseResult && responseResult.status === 400) {
                if(typeof responseResult.data.data === "object")
                {
                    const errorMessagesKeys = Object.keys(responseResult.data.data);
                    errorMessagesKeys.map((key)=>{
                    
                        responseResult.data.data[key].map((message)=>{
                            toast.error(message)
                        })
                    })
                }
                else{
                    toast.error(responseResult.data.data)
                }
                
            }
            else if(responseResult && responseResult.status === 401) {
                toast.error(responseResult.data.data)
                cookies.remove("token");
                window.location.href = "/"
            }
            else
            {
                toast.error("network error")
            }
        }
        setloading(false)
    };
    const activateObject = async (object) => {
        setloading(true)
        try {
            const result=await axios({
                url: Host + "users/activate",
                method: "post",
                headers: {
                "Authorization" : `Bearer ${token}`,
                    Accept:"application/json",
                    'X-localization':language,
                },
                data:{
                    user_id:object.id,
                    active:object.active==1?0:1
                }
        
            })
            if(result && result.status == 200)
            {
                fetchData();
            } else if (result.data.status === false) {
                toast.error("Error")
            }
        } catch (error) {
            const responseResult=error.response            
            if (responseResult && responseResult.status === 400) {
                if(typeof responseResult.data.data === "object")
                {
                    const errorMessagesKeys = Object.keys(responseResult.data.data);
                    errorMessagesKeys.map((key)=>{
                    
                        responseResult.data.data[key].map((message)=>{
                            toast.error(message)
                        })
                    })
                }
                else{
                    toast.error(responseResult.data.data)
                }
                
            }
            else if(responseResult && responseResult.status === 401) {
                toast.error(responseResult.data.data)
                cookies.remove("token");
                window.location.href = "/"
            }
            else
            {
                toast.error("network error")
            }
        }
        setloading(false)
    };
    const createObject = async (object) => {
        setselectedUser(null)
        setshowUserForm(true)
    };

    const handleSetshowUserForm = (openStatus,needsReload) => {
      if(needsReload)
      fetchData();
      setshowUserForm(openStatus)
    };

    const handleSetshowUserRoleForm = (openStatus,needsReload) => {
        if(needsReload)
            fetchData();
        setshowUserRoleForm(openStatus)
    };
    
    
    useEffect(() => {        
        fetchData();
    }, [])
    
    return (
        <>
            {showUserForm?
                <UserForm user={selectedUser} showUserForm={showUserForm} setshowUserForm={handleSetshowUserForm} />
            :null}
            {showUserRoleForm?
                <UserRoleForm user={selectedUser} showUserRoleForm={showUserRoleForm} setshowUserRoleForm={handleSetshowUserRoleForm} />
            :null}
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">User List <Button style={{float:'right'}} onClick={()=>{createObject()}}>create</Button></div>
                            <div className="card-body">
                            <table>
                                <thead>
                                    <tr>
                                        <th>1</th>
                                        <th>Full Name</th>
                                        <th>Username</th>
                                        <th>phone</th>
                                        <th>department</th>
                                        <th>active</th>
                                        <th>edit</th>
                                        <th>show role</th>
                                        <th>delete</th>
                                        <th>Activate/Disable</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {   
                                    state?.users?.data ? 
                                        state?.users?.data?.map((object) => (
                                                <tr key={object?.id}>
                                                    <td>{object?.id}</td>
                                                    <td>{object?.full_name}</td>
                                                    <td>{object?.username}</td>
                                                    <td>{object?.phone}</td>
                                                    <td>{object?.department?.name}</td>
                                                    <td>{object?.active==1?"active":"disabled"}</td>
                                                    <td><Button onClick={()=>{updateObject(object)}}>update</Button></td>
                                                    <td><Button style={{backgroundColor:'yellow',color:'black'}} onClick={()=>{showRoles(object)}}>show roles</Button></td>
                                                    <td><Button style={{backgroundColor:'red',color:'white'}} onClick={()=>{deleteObject(object)}}>delete</Button></td>
                                                    <td><Button style={{backgroundColor:object.active==1?'green':'orange',color:'white'}} onClick={()=>{activateObject(object)}}>activate/disable</Button></td>
                                                    
                                                </tr>
                                        )) : "Loading..."
                                }
                                </tbody>
                            </table>
                                <div>
                                    <Pagination
                                        activePage={state?.users?.current_page ? state?.users?.current_page : 0}
                                        itemsCountPerPage={state?.users?.per_page ? state?.users?.per_page : 0 }
                                        totalItemsCount={state?.users?.total ? state?.users?.total : 0}
                                        onChange={(pageNumber) => {
                                            fetchData(pageNumber)
                                        }}
                                        pageRangeDisplayed={8}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        firstPageText="First Page"
                                        lastPageText="Last Lage"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Users;